/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AgentBillingResponseDto } from '../models/AgentBillingResponseDto';
import type { AgentsBillingResponseDto } from '../models/AgentsBillingResponseDto';
import type { PageConversationBillingResponseDto } from '../models/PageConversationBillingResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
import { AgentAnalyticsResponse } from '../models/AgentAnalyticsResponse';
export class ConversationBillingControllerService {
  /**
   * @returns any Refreshes the view with and fills it with the latest data
   * @throws ApiError
   */
  public static refreshConversationBilling(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/conversations/billing/refresh',
    });
  }
  /**
   * @returns string Time when the view was updated last time
   * @throws ApiError
   */
  public static getLastRefreshedDate(
    xAiAgentOrganizationContext: string
  ): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/conversations/billing/last-refresh-date',
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      errors: {
        404: `No information when the view was updated`,
      },
    });
  }
  /**
   * @param xAiAgentOrganizationContext
   * @param agentId
   * @param conversationId
   * @param startTime
   * @param endTime
   * @param page Zero-based page index (0..N)
   * @param size The size of the page to be returned
   * @param sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @returns PageConversationBillingResponseDto Success response
   * @throws ApiError
   */
  public static getConversationBilling(
    xAiAgentOrganizationContext: string,
    agentId?: string,
    conversationId?: string,
    startTime?: string,
    endTime?: string,
    page?: number,
    size: number = 1000,
    sort?: Array<string>
  ): CancelablePromise<PageConversationBillingResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/conversations/billing/conversations',
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      query: {
        agent_id: agentId,
        conversation_id: conversationId,
        start_time: startTime,
        end_time: endTime,
        page: page,
        size: size,
        sort: sort,
      },
    });
  }
  /**
   * @param xAiAgentOrganizationContext
   * @param startTime
   * @param endTime
   * @returns AgentsBillingResponseDto Success response
   * @throws ApiError
   */
  public static getAgents(
    xAiAgentOrganizationContext: string,
    startTime?: string,
    endTime?: string
  ): CancelablePromise<AgentsBillingResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/conversations/billing/agents',
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      query: {
        start_time: startTime,
        end_time: endTime,
      },
    });
  }
  /**
   * @param xAiAgentOrganizationContext
   * @param id
   * @param startTime
   * @param endTime
   * @returns AgentBillingResponseDto Success response
   * @throws ApiError
   */
  public static getAgent(
    xAiAgentOrganizationContext: string,
    id: string,
    startTime?: string,
    endTime?: string
  ): CancelablePromise<AgentBillingResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/conversations/billing/agents/{id}',
      path: {
        id: id,
      },
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      query: {
        start_time: startTime,
        end_time: endTime,
      },
      errors: {
        404: `Agent not found`,
      },
    });
  }

  /**
   * Get agent analytics
   * Fetches analytics data for a specific agent including call metrics, performance statistics, and usage patterns.
   * @param xAiAgentOrganizationContext
   * @param agentId
   * @param from
   * @param to
   * @param period
   * @returns AgentAnalyticsResponse Analytics data retrieved successfully
   * @throws ApiError
   */
  public static getAgentAnalytics(
    xAiAgentOrganizationContext: string,
    agentId: string,
    from: string,
    to: string
  ): CancelablePromise<AgentAnalyticsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/dashboard/agents/{agentId}/summary',
      path: {
        agentId: agentId,
      },
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      query: {
        from: from,
        to: to,
      },
      errors: {
        400: `Invalid request parameters`,
        404: `Agent not found`,
        500: `Internal server error`,
      },
    });
  }
}
